import { render, staticRenderFns } from "./PackingSlip.vue?vue&type=template&id=604c37ea"
import script from "./PackingSlip.vue?vue&type=script&lang=js"
export * from "./PackingSlip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports